import { createStyles } from '@mantine/styles';

export default createStyles({
  // required to allow dropdown padding override with styles and classNames
  dropdown: { padding: 4 },
});
